<template>
  <Swiper class="box" :options="options" ref="swiper">
    <SwiperSlide v-for="item in imageList">
      <img :src="item" />
    </SwiperSlide>
    <!-- 左箭头 -->
    <div slot="button-prev" class="swiper-button-prev"></div>
    <!-- 右箭头 -->
    <div slot="button-next" class="swiper-button-next"></div>
    <!-- 分页器 -->
    <div slot="pagination" class="swiper-pagination"></div>
  </Swiper>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      imageList: [
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/5UggjbbP-1654009776260.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/YAbnUF2M-1654009775998.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/nyiIMiEL-1654009777024.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/uwOGVuLB-1654009777931.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-05-31/k2AtDceh-1654009778595.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-06-07/Sw7pAXU0-1654573955653.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-06-07/Zg6xvzzp-1654573955392.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-06-20/vfr2Evaw-1655692688377.jpg',
        'https://image2.cqcb.com/d/file/topics/activity/2022-06-07/PtrymKCi-1654573955036.jpg',
      ],
      // options配置项: 使用swiper官网的配置项即可
      options: {
        //导航前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        //自动轮播图
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        //无缝衔接
        loop: true,
        //分页器配置项
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 点击分页器小球进行轮播图切换
        },
        //切换效果
        effect: 'cube',
      },
    };
  },
  mounted() {
    //鼠标进入-暂停
    this.$refs.swiper.$el.onmouseenter = () => {
      this.$refs.swiper.$swiper.autoplay.stop();
    };
    //鼠标离开-开始
    this.$refs.swiper.$el.onmouseleave = () => {
      this.$refs.swiper.$swiper.autoplay.start();
    };
  },
};
</script>

<style scoped>
.box {
  width: 300px;
  height: 400px;
  border: 1px solid red;
  margin: 10px auto;
}
img {
  width: 100%;
  height: 100%;
  background: cyan;
}
</style>
